import { withAuth } from 'next-auth/middleware'
import { NextResponse } from 'next/server'
import type { JWT } from 'next-auth/jwt'

export default withAuth(
  function middleware(req) {
    const { pathname } = req.nextUrl
    const token = req.nextauth.token as JWT | null

    // Moderator/Admin only routes — restrict access to non-authorized roles
    if (pathname.startsWith('/admin') || pathname.startsWith('/moderacao')) {
      if (!token || (token.role !== 'MODERATOR' && token.role !== 'ADMIN')) {
        return NextResponse.redirect(new URL('/', req.url))
      }
    }

    return NextResponse.next()
  },
  {
    callbacks: {
      authorized({ token }) {
        // Routes requiring any authentication — allow if token exists
        return !!token
      },
    },
  }
)

export const config = {
  matcher: [
    '/perfil',
    '/perfil/:path*',
    '/spots/novo',
    '/spots/:id/editar',
    '/spots/:id/review',
    '/admin/:path*',
    '/moderacao/:path*',
  ],
}
